module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_8004.79f99ad5.png";